import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, Routes } from '@angular/router';

import { UserRouteAccessService } from './core/auth/user-route-access.service';
import { UserRouteAdminAccessService } from './core/auth/user-route-admin-access.service';
import { Authority } from './core/model/authority.model';
import { HOME_ROUTE } from './home/home.route';

export const routes: Routes = [
  HOME_ROUTE,
  {
    path: 'progetti',
    data: {
    },
    loadChildren: () => import('./pages/projects/projects.route').then(m => m.PROJECTS_ROUTE),
    canActivate: [(route: ActivatedRouteSnapshot) => inject(UserRouteAdminAccessService).canActivate(route)]
  },
  {
    path: 'progetti-gitops',
    data: {
    },
    loadChildren: () => import('./pages/gitops/gitops-projects.route').then(m => m.GITOPS_PROJECTS_ROUTE),
    canActivate: [(route: ActivatedRouteSnapshot) => inject(UserRouteAdminAccessService).canActivate(route)]
  },
  {
    path: 'deleghe',
    data: {
    },
    loadChildren: () => import('./pages/delegation/delegation.route').then(m => m.DELEGATION_ROUTE),
    canActivate: [(route: ActivatedRouteSnapshot) => inject(UserRouteAdminAccessService).canActivate(route)]
  },
  /* Jira 1502
  Archiviazione progetti */
  {
    path: 'archiviazione',
    data: {
    },
    loadChildren: () => import('./pages/sharedComponent/archiving/archiving.route').then(m => m.ARCHIVING_ROUTE),
    canActivate: [(route: ActivatedRouteSnapshot) => inject(UserRouteAdminAccessService).canActivate(route)]
  },
  /* Jira 1502
  Archiviazione progetti */
  {
    path: 'admin',
    data: {
      authorities: [Authority.ROLE_ADMIN]
    },
    loadChildren: () => import('./pages/admin/admin.route').then(m => m.ADMIN_ROUTES),
    canActivate: [(route: ActivatedRouteSnapshot) => inject(UserRouteAccessService).canActivate(route)]
  },
  { path: '**', redirectTo: '/' }
];
